import * as React from 'react';
import * as styles from './Preview.css';
import { inject, observer } from 'mobx-react';
import { Store } from '../stores';
import { IAViewer } from '../../viewer/Viewer';
import { Helper } from '../../../Helper';
import { IComposerImage } from '../../../interfaces/IComposerImage';

export interface IProps {
  store?: Store;
  imageViewerImagesToShow: (images: IComposerImage[]) => void;
  imageViewerIndexToShow: (index: number) => void;
}

export interface IState {
}

@inject('store')
@observer
export class Preview extends React.Component<IProps, IState> {

  constructor(props: IProps) {
    super(props);
    this.state = {
    }
  }

  public render(): JSX.Element {
    let videoUrl = this.props.store.cover.video.url;
    if ((location.href.includes("sharepoint.com") && this.props.store.cover.video.embedCode) || (videoUrl == undefined && this.props.store.cover.video.embedCode)) {
      videoUrl = Helper.getVideoSrcFromEmbedCode(this.props.store.cover.video.embedCode);
    }
    return (
      <div className={styles.IA_preview}>
        <IAViewer
          isPreview={true}
          fontSlots={this.props.store.fontSlots}
          token={this.props.store.token}
          tenant={this.props.store.tenant}
          environment={this.props.store.environment}
          isMobile={this.props.store.isMobile}
          highlightColor={this.props.store.highlightColor}
          component={this.props.store.component}
          instance={this.props.store.instance}
          id={this.props.store.id ? this.props.store.id.toString() : Helper.getRandomStringKey()}
          imageUrl={this.props.store.cover?.image?.url}
          imageCropSettings={this.props.store.cover?.image?.cropSettings}
          onlyShowCoverImageInRollup={this.props.store.cover.image.onlyShowCoverImageInRollup}
          videoUrl={videoUrl}
          title={this.props.store.title && this.props.store.title?.text ? this.props.store.title?.text : undefined}
          teaser={this.props.store.teaser && this.props.store.teaser?.text ? this.props.store.teaser?.text : undefined}
          composerComponents={this.props.store.contentComponents}
          categories={this.props.store.subjects?.categories}
          startDate={this.props.store.startDate}
          endDate={this.props.store.endDate}
          allDayEvent={this.props.store.allDayEvent}
          location={this.props.store.location?.text}
          modified={new Date()}
          author={this.props.store.user}
          contacts={this.props.store.contacts.users}
          editor={this.props.store.user}
          attachments={this.props.store.attachments && this.props.store.attachments?.files ? this.props.store.attachments?.files : undefined}
          likesEnabled={this.props.store.likesEnabledOnInstance && this.props.store.likesEnabled}
          commentsEnabled={this.props.store.commentsEnabledOnInstance && this.props.store.commentsEnabled}
          likesOnCommentsEnabled={this.props.store.commentsEnabled}
          imageViewerImagesToShow={(images: IComposerImage[]) => {
            this.props.imageViewerImagesToShow(images);
          }}
          imageViewerIndexToShow={(index: number) => {
            this.props.imageViewerIndexToShow(index);
          }}
          linkEditorImageTarget={this.props.store.linkEditorImageTarget}
          iaMessageBgImagesFromBlob={{ StandardLarge: this.props.store.cover?.image?.imageBlobUrl }}
          padding={this.props.store.isMobile ? "0 30px" : "0 40px"}
        />
      </div>
    );
  }
}